export const formatOrderNotes = (notes) => {
    if (!notes) return '';
    let formattedNotes = notes;
    
    // Regex to match the exact pattern generated by PuntosVenta
    const splitRegex = /\[SPLIT\] CASH_USD=([\d.]+) CASH_COP=([\d.]+) TRANSFER_USD=([\d.]+) TRANSFER_COP=([\d.]+)/;
    const match = notes.match(splitRegex);
    
    if (match) {
        const cashUsd = parseFloat(match[1]);
        const cashCop = parseFloat(match[2]);
        const transUsd = parseFloat(match[3]);
        const transCop = parseFloat(match[4]);
        
        let splitDetails = [];
        if (cashUsd > 0) splitDetails.push(`Efec: $${cashUsd.toFixed(2)}`);
        if (cashCop > 0) splitDetails.push(`Efec: COP ${cashCop.toLocaleString('es-CO', {maximumFractionDigits:0})}`);
        if (transUsd > 0) splitDetails.push(`Trans: $${transUsd.toFixed(2)}`);
        if (transCop > 0) splitDetails.push(`Trans: COP ${transCop.toLocaleString('es-CO', {maximumFractionDigits:0})}`);
        
        let readableSplit = 'Pago Dividido';
        if (splitDetails.length > 0) {
            readableSplit += ` (${splitDetails.join(' | ')})`;
        }
        
        // Replace the raw string with the human readable version
        formattedNotes = formattedNotes.replace(splitRegex, readableSplit);
    }
    
    // Clean up any stray pipes that might have been left if notes was only the [SPLIT] text
    formattedNotes = formattedNotes.replace(/^[\s|]+|[\s|]+$/g, '');
    
    return formattedNotes;
};
